import { Injectable } from '@angular/core';
import { EnvConfigurationService } from '../envconf/envconf.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountManagerDto, AccountManagerRequestDto } from '../../models/distributor/account-manager-dto';

@Injectable({
  providedIn: 'root'
})
export class AccountManagerService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/accountmanagers`;

  constructor(private readonly http: HttpClient) {}

  findByDistributorId(distributorId: number): Observable<AccountManagerDto[]> {
    return this.http.get<AccountManagerDto[]>(`${this.endpoint}?distributorId=${distributorId}`);
  }

  create(accountManager: AccountManagerRequestDto): Observable<AccountManagerDto> {
    return this.http.post<AccountManagerDto>(this.endpoint, accountManager);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${id}`);
  }

  testSendNewsletterEmail(): Observable<void> {
    return this.http.get<void>(`${this.endpoint}/test-send-newsletter-email`);
  }
}
